/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Start_AInputs */

const en_mk_tb_faq_start_a = /** @type {(inputs: Mk_Tb_Faq_Start_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can start from a PRD, a short brief or a synced codebase. Review proposed requirements, source coverage and conflicts before applying the scope. An observed codebase is not automatically treated as verified work.`)
};

const id_mk_tb_faq_start_a = /** @type {(inputs: Mk_Tb_Faq_Start_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda bisa mulai dari PRD, brief singkat, atau codebase yang sudah disinkronkan. Tinjau usulan kebutuhan, cakupan sumber, dan konflik sebelum menerapkan lingkup. Codebase yang teramati tidak otomatis dianggap sebagai pekerjaan terverifikasi.`)
};

/**
* | output |
* | --- |
* | "You can start from a PRD, a short brief or a synced codebase. Review proposed requirements, source coverage and conflicts before applying the scope. An obser..." |
*
* @param {Mk_Tb_Faq_Start_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_start_a = /** @type {((inputs?: Mk_Tb_Faq_Start_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Start_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_start_a(inputs)
	return en_mk_tb_faq_start_a(inputs)
});